import store from 'store2'

import queryString from 'query-string'

export const getToken = () => (store.get('token') as string) || ''

export const getTokenOnScriptLoad = () =>
  (queryString.parse(window.location.search).token as string) || getToken()
